// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"eUWeN":[function(require,module,exports) {
require("b66b7b7edbd08c72").register(JSON.parse('{"aJUMN":"removeAccount.d5d247fd.js","91khd":"person_placeholder.d231642f.svg","ikhXE":"removeAccount.9f3487c5.js"}'));

},{"b66b7b7edbd08c72":"fyJL2"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = {};
function register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)mapping[keys[i]] = pairs[keys[i]];
}
function resolve(id) {
    var resolved = mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"gM4mH":[function(require,module,exports) {
/**
 * Created By Hensi Murcia
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _common = require("./common");
var _personPlaceholderSvg = require("url:../images/person_placeholder.svg");
var _personPlaceholderSvgDefault = parcelHelpers.interopDefault(_personPlaceholderSvg);
"use strict";
let user;
let isRecentLogin = false;
let isEmail;
let dvToast;
let dbUser;
let recaptchaVerifier;
$("document").ready(function() {
    initLs();
    initAuthLs();
});
/**
 * check if user logged in
 */ function initAuthLs() {
    if (window.location.search.includes("action=success")) isRecentLogin = true;
    firebase.auth().onAuthStateChanged(function(data) {
        if (data) {
            //User is logged in
            user = data;
            initUi();
        } else {
            //User needs to log in
            let modLogin = document.getElementById("modLogin");
            (0, _common.setDisplay)(modLogin, "flex");
        }
    });
}
function initUi() {
    let spAcc = document.getElementById("spAcc");
    let ivUser = document.getElementById("ivUser");
    isEmail = user.email != null;
    spAcc.textContent = isEmail ? user.email : user.phoneNumber;
    ivUser.src = (0, _personPlaceholderSvgDefault.default);
    $(ivUser).on("error", function() {
        ivUser.src = (0, _personPlaceholderSvgDefault.default);
    });
    dbUser = firebase.database().ref(`Users/${user.uid}`);
    dbUser.child("info").once("value", function(data) {
        if (data.exists) {
            let info = data.val();
            ivUser.src = info.profile_Image ? info.profile_Image : (0, _personPlaceholderSvgDefault.default);
        }
    });
}
function initLs() {
    dvToast = document.getElementById("toast");
    let btnLogin = document.getElementById("btnLogin");
    $(btnLogin).click(function() {
        window.location.replace("../login.html?action=manage");
    });
    let btnContinue = document.getElementById("btnContinue");
    let modDeleteAcc = document.getElementById("modDeleteAcc");
    let modPwVerify = document.getElementById("modPwVerify");
    let modPhoneVerify1 = document.getElementById("modPhoneVerify");
    $(btnContinue).click(function() {
        if (isRecentLogin) (0, _common.setDisplay)(modDeleteAcc, "flex");
        else if (isEmail) (0, _common.setDisplay)(modPwVerify, "flex");
        else {
            initCaptcha();
            (0, _common.setDisplay)(modPhoneVerify1, "flex");
        }
    });
    let btnPwContinue = modPwVerify.querySelector(".btnContinue");
    let btnPwCancel = modPwVerify.querySelector(".btnCancel");
    let inPw = document.getElementById("inPw");
    let modError = document.getElementById("modError");
    let btnOk = document.getElementById("btnOk");
    $(btnPwContinue).click(function() {
        let pw = inPw.value.trim();
        if (pw) {
            inPw.value = "";
            verifyEmail(pw, modDeleteAcc, modError);
            (0, _common.setDisplay)(modPwVerify, "none");
        } else {
            $(inPw).shake();
            (0, _common.showToast)("Cannot be empty", dvToast, null);
        }
    });
    $(btnPwCancel).click(function() {
        (0, _common.setDisplay)(modPwVerify, "none");
    });
    $(btnOk).click(function() {
        (0, _common.setDisplay)(modError, "none");
    });
    let btnPhoneContinue = modPhoneVerify1.querySelector(".btnContinue");
    let btnPhoneCancel = modPhoneVerify1.querySelector(".btnCancel");
    $(btnPhoneContinue).click(function() {
        verifyPhone(modPhoneVerify1, modDeleteAcc, modError);
    });
    $(btnPhoneCancel).click(function() {
        (0, _common.setDisplay)(modPhoneVerify1, "none");
    });
    let btnDeleteAcc = document.getElementById("btnDeleteAcc");
    let btnDelCancel = modDeleteAcc.querySelector(".btnCancel");
    $(btnDeleteAcc).click(function() {
        (0, _common.setDisplay)(modDeleteAcc, "none");
        deleteAccount();
    });
    $(btnDelCancel).click(function() {
        (0, _common.setDisplay)(modDeleteAcc, "none");
    });
    let btnOkSuccess = document.getElementById("btnOkSuccess");
    $(btnOkSuccess).click(function() {
        window.location.replace("../login.html");
    });
}
function initCaptcha() {
    let dvContainer = modPhoneVerify.querySelector("container");
    let params = {
        type: "image",
        size: "normal",
        badge: "bottomleft"
    };
    let recaptchaVerifier = new firebase.auth.RecaptchaVerifier(dvContainer, params, firebase.app());
    recaptchaVerifier.render();
}
function verifyPhone(modPhoneVerify1, modDeleteAcc, modError) {
    user.reauthenticateWithPhoneNumber(user.phoneNumber, recaptchaVerifier).then((confirmationResult)=>{
        let modVerifyCode = document.getElementById("modVerifyCode");
        let btnCodeVerify = modVerifyCode.querySelector("btnContinue");
        let inCode = document.getElementById("inCode");
        (0, _common.setDisplay)(modPhoneVerify1, "none");
        (0, _common.setDisplay)(modVerifyCode, "flex");
        $(btnCodeVerify).unbind();
        $(btnCodeVerify).click(function() {
            let code = inCode.value.trim();
            if (!code) {
                $(inCode).shake();
                (0, _common.showToast)("Cannot be empty", dvToast, null);
                return;
            }
            confirmationResult.confirm(code).then(function(userCredential) {
                //successfully verified
                isRecentLogin = true;
                inCode.value = "";
                (0, _common.setDisplay)(modVerifyCode, "none");
                (0, _common.setDisplay)(modDeleteAcc, "flex");
            }).catch((e)=>{
                inCode.value = "";
                (0, _common.setDisplay)(modVerifyCode, "none");
                (0, _common.setDisplay)(modError, "flex");
            });
        });
    }).catch((e)=>{
        (0, _common.setDisplay)(modPhoneVerify1, "none");
        (0, _common.setDisplay)(modError, "flex");
    });
}
function deleteAccount() {
    let modDeletingAcc = document.getElementById("modDeletingAcc");
    (0, _common.setDisplay)(modDeletingAcc, "flex");
    user.delete().then(()=>{
        let modSuccess = document.getElementById("modSuccess");
        (0, _common.setDisplay)(modSuccess, "flex");
        (0, _common.setDisplay)(modDeletingAcc, "none");
    }).catch((error)=>{
        let modError = document.getElementById("modError");
        let pMsg = document.getElementById("pMsg");
        pMsg.textContent = "Could not delete account";
        (0, _common.setDisplay)(modError, "flex");
        (0, _common.setDisplay)(modDeletingAcc, "none");
    });
}
function verifyEmail(pw, modDeleteAcc, modError) {
    let creds = firebase.auth.EmailAuthProvider.credential(user.email, pw);
    user.reauthenticateWithCredential(creds).then(()=>{
        isRecentLogin = true;
        (0, _common.setDisplay)(modDeleteAcc, "flex");
    }).catch((error)=>{
        (0, _common.setDisplay)(modError, "flex");
    });
}
jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
    intShakes = intShakes || 4;
    intDistance = intDistance || 2;
    intDuration = intDuration || 500;
    this.each(function() {
        $(this).css("position", "relative");
        for(var x = 1; x <= intShakes; x++)$(this).animate({
            left: intDistance * -1
        }, intDuration / intShakes / 4).animate({
            left: intDistance
        }, intDuration / intShakes / 2).animate({
            left: 0
        }, intDuration / intShakes / 4);
    });
    return this;
};

},{"./common":"loJev","url:../images/person_placeholder.svg":"kB9oD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kB9oD":[function(require,module,exports) {
module.exports = require("2378acb4a2e4e33a").getBundleURL("aJUMN") + require("8bdd3a8e046862a5").resolve("91khd");

},{"2378acb4a2e4e33a":"c7Tr5","8bdd3a8e046862a5":"fyJL2"}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["eUWeN","gM4mH"], "gM4mH", "parcelRequire460e")

//# sourceMappingURL=removeAccount.d5d247fd.js.map
